module.exports = __webpack_public_path__ + "img/52002740_L.f262dab0.png";